import * as Yup from 'yup';
import moment from 'moment';
import editarArea from './editarAreaFormModel';
const {
  formField: {

    // DATOS CLIENTE 
    e_name,
    e_description

  }

} = editarArea;


export default [

  // INFORMACION BASICA 
  Yup.object().shape({ 
    [e_name.name]: Yup.string().required(`${e_name.requiredErrorMsg}`),    
    [e_description.name]: Yup.string().required(`${e_description.requiredErrorMsg}`),
  })
  
];  

    